/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// eslint-disable-next-line import/no-extraneous-dependencies
import type { Property } from 'csstype';

const COLORS: Record<string, Property.Color> = {
  Background: '#096ba8',
  HeaderStepBorder: '#98a7bf',
  SectionBorderColor: '#d9d9d9',
  DividerColor: '#eaecf0',
  DividerBlueColor: '#72b7e4',
  GreyDashboardColor: '#f5f6fa',
  GreenCardColor: '#8eff8e79',
  GreenTextColor: '#16a34a',
  BlueTextColor: '#006594',
  LightBlueCardColor: '#85c2ff7c',
  MarinBlueCardColor: '#a9e8e1',
  MarinBlueTextColor: '#02b4a1',
  LightGreyCardColor: '#dadce0',
  GreyTextColor: '#666d7d',
  OrangeCardColor: '#ffddab',
  OrangeTextColor: '#fd9c16',
  RedCardColor: '#ff6e6e50',
  PurpleCardColor: '#d39eff',
  PinkCardColor: '#ffd6ff',
  PinkTextColor: '#f51289',
  BlueListColor: '#2081e2',
  RedListColor: '#9e0000',
  PurpleListColor: '#7a007a',
  PurpleTextColor: '#9d26ff',
  GreenListColor: '#00bb64',
};

export default COLORS;
